<title>{{ serviceTechnologyProviders.htmlTitle }}</title>
<app-banner [banner]="serviceTechnologyProviders.banner" [isCommonBanner]="true" [isDefaultPageBanner]="false"></app-banner>
<div class="container-fluid">
  <app-service-technology-providers-table-section [tableSections]="serviceTechnologyProviders.tableSection"></app-service-technology-providers-table-section>
</div>
